(function () {
  const KEY = 'wishlist_handles';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e){ return []; }
  }
  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length }}));
  }

  function has(handle) {
    return load().includes(handle);
  }

  function add(handle) {
    const list = load();
    if (!list.includes(handle)) list.push(handle);
    save(list);
  }

  function remove(handle) {
    save(load().filter(h => h !== handle));
  }

  function toggle(handle) {
    if (has(handle)) remove(handle);
    else add(handle);
  }

  function updateHeaderCount() {
    const el = document.getElementById('wishlist-count');
    if (!el) return;
    const count = load().length;
    el.textContent = count;
    el.style.display = count ? 'inline-flex' : 'none';
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      const handle = btn.getAttribute('data-wishlist-handle');
      const active = has(handle);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

// ✅ one delegated click handler (works even after section reloads)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;

  e.preventDefault();

  const handle =
    btn.getAttribute('data-wishlist-handle') ||
    (btn.dataset ? btn.dataset.wishlistHandle : null);

  if (!handle) return;

  toggle(handle);
  updateHeaderCount();
  syncButtons();
});

// ✅ run once after DOM exists
document.addEventListener('DOMContentLoaded', () => {
  updateHeaderCount();
  syncButtons();
});

document.addEventListener('DOMContentLoaded', bindWishlistButtons);
document.addEventListener('shopify:section:load', bindWishlistButtons);

  window.addEventListener('wishlist:updated', () => {
    updateHeaderCount();
    syncButtons();
  });

  // init
  updateHeaderCount();
  syncButtons();

  // expose minimal API if needed
  window.Wishlist = { load, has, add, remove, toggle };
})();